import { convertDate } from "./../../../../shared/util/formatDate";
import {
	IAuditorModel,
	ISalvarAlocarEquipeModel,
} from "./../../../../models/alocar-equipe-component";
import { IAlocarEquipeModel } from "src/app/models/alocar-equipe-component";
import { AlocarEquipeComponent } from "./../../../../shared/components/alocar-equipe/alocar-equipe.component";
import {
  AfterViewInit,
  Component,
  Input, OnDestroy,
  OnInit,
  ViewChild
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ToastrService } from "ngx-toastr";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseFormComponent } from "src/app/shared/components/base-form/base-form.component";
import { IOsaModel, IPlanejamentoOsaUgSubTipoModel } from "src/app/models/osa-model";
import { OsaService } from "src/app/services/osa.service";
import { Subscription } from "rxjs";
import { SharedService } from "src/app/services/shared.service";
import { CoordenacaoService } from "src/app/services/coordenacao.service";
import { IAuditorCoordenacaoModel } from "src/app/models/auditor-coordenacao.model";
import { SubtipoAuditoriaService } from "src/app/services/subtipo-auditoria.service";
import { defaultDataAcessor } from "src/app/core/helpers/mat-sort-data-accessor";
import { ISubtipoAuditoriaModel } from "src/app/models/subtipo-auditoria.model";
import { IPaaCoordenacaoAuditorModel } from "src/app/models/paa-coordenacao-auditor.model";
import { IPlanejamentoSubtipoAuditoriaModel } from "src/app/models/planejamento-subtipo-auditoria.model";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2";
import { IUnidadeGestoraModel } from "../../../../models/unidade-gestora.model";
import { PaaService } from "../../../../services/paa.service";
import { DateHelper } from "../../../../core/helpers/date.helper";
import { ModalAlocarEquipeOsaComponent } from "../../modal-alocar-equipe/modal-alocar-equipe-osa.component";
import {
  ModalIncluirUgComponentComponent
} from "../../../../shared/components/unidade-gestora/modal-incluir-ug-component/modal-incluir-ug-component.component";
import {
  ModalVincularUgComponentComponent
} from "../../modal-vincular-ug-component/modal-vincular-ug-component.component";
import { IOsaFiltroModel } from "../../../../models/osa-filtro-model";

export interface PlanejamentoUgSubtipo {
	planejamentoId: number;
	unidadeGestora: IUnidadeGestoraModel;
	subtipoAuditoria: ISubtipoAuditoriaModel;
}

export interface ISubtipoAuditoriaDisplay {
  id: number;
  nome: string;
}

export interface IUnidadeGestoraDisplay {
  id: number;
  nome: string;
  sigla: string;
}


export interface IPlanejamentoUgSubTipoComOsa extends IPlanejamentoOsaUgSubTipoModel {
  numeroOsa: string | null;
}


@Component({
	selector: "app-aba-informacoes-basicas",
	templateUrl: "./aba-informacoes-basicas.component.html",
	styleUrls: ["./aba-informacoes-basicas.component.scss"],
})
export class AbaInformacoesBasicasComponent
  extends BaseFormComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  clickEventSubscription: Subscription;
  public subTipoModel: ISubtipoAuditoriaModel[] =
    [] as ISubtipoAuditoriaModel[];
  public unidadeGestoraSubtipo: IUnidadeGestoraDisplay[] =
    [] as IUnidadeGestoraDisplay[];
  public displayedColumns: string[] = ["auditor","unidadeVinculadas", "acoes"];
  public displayedColumnsSubtipo: string[] = ["nome"];
  public subtipoDataSource = new MatTableDataSource<ISubtipoAuditoriaDisplay>([]);
  public equipeDataSource = new MatTableDataSource<IAuditorModel>([]);
  public model: IOsaModel = {} as IOsaModel;
  public coordenadoresAuditoria = [] as IAuditorCoordenacaoModel[];
  public semDados = true;
  public id: number;
  public subtipoNoData = true;
  public semDadosSubTipo = true;
  public isSubsidiaria = false;
  public subTipoSelecionado: number;
  public submitted: boolean = false;
  minDataFim: string | null = null;
  dataElaboracao: string | null = null;
  public ocultaSalvar = false;
  public dataSourceUgSubTipos = new MatTableDataSource<IPlanejamentoUgSubTipoComOsa>(
    []
  );
  public displayedColumnsUg: string[] = ["ug", "subtipo", "statusUg","numeroOsa"];
  public alocarEquipeModel: IAlocarEquipeModel = {} as IAlocarEquipeModel;
  private isCalculating = false;
  public versao: boolean = false;
  private dadosEquipeParaSalvar: ISalvarAlocarEquipeModel | null = null;
  @Input() public visualizar;

  @ViewChild("TableOnePaginator", { static: true })
  tableOnePaginator: MatPaginator;
  @ViewChild("tabela1", { static: true }) tabela1: MatSort;

  @ViewChild("TableTwoPaginator", { static: true })
  tableTwoPaginator: MatPaginator;
  @ViewChild("tabela2", { static: true }) tabela2: MatSort;

  @ViewChild("TableTreePaginator", { static: true })
  tableTreePaginator: MatPaginator;
  @ViewChild("tabela3", { static: true }) tabela3: MatSort;

  public form = new FormGroup({
    dataInicioRealizacao: new FormControl("", Validators.required),
    dataFimRealizacao: new FormControl("", Validators.required),
    notaRodape: new FormControl(""),
    auditor: new FormControl("", Validators.required),
    qtdeDiasUteisExecucao: new FormControl(null, Validators.required),
    dataConstatacoesPreliminares: new FormControl(null),
    dataApresentacaoRelatorio: new FormControl(null),
    periodoAuditado: new FormControl(""),
  });

  private validacaoRequestSubscription: Subscription;
  private jaRespondeuValidacao = false;
  private sincronizacaoSubscription: Subscription;

  constructor(
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router,
    public localeService: BsLocaleService,
    public matDialog: MatDialog,
    private osaService: OsaService,
    private sharedService: SharedService,
    private paaService: PaaService,
    private coordenacaoService: CoordenacaoService,
    private subtipoService: SubtipoAuditoriaService,
    private dateHelper: DateHelper,
  ) {
    super(route, toastr, router, localeService, matDialog);

    if (this.router.url.includes("nova-versao")) {
      this.versao = true
    }

    this.clickEventSubscription = this.sharedService
      .getEvent()
      .subscribe(() => {
        this.executarSalvamento();
      });

    this.sincronizacaoSubscription = this.sharedService
      .getSincronizarDadosEvent()
      .subscribe(() => {
        this.sincronizarDadosNoModel();
      });
  }

  ngOnInit(): void {

    this.form.get("dataInicioRealizacao")?.valueChanges.subscribe(() => {
      if (!this.isCalculating) {
        this.recalcularQtdeDiasUteis();
      }
    });

    this.form.get("dataFimRealizacao")?.valueChanges.subscribe(() => {
      if (!this.isCalculating) {
        this.recalcularQtdeDiasUteis();
      }
    });

    // this.form.get("qtdeDiasUteisExecucao")?.valueChanges.subscribe(() => {
    //   if (!this.isCalculating) {
    //     this.calcularDataFimRealizacao();
    //   }
    // });

    this.form.get("periodoAuditado")?.valueChanges.subscribe((value) => {
      if (this.model) {
        this.model.periodoAuditado = value;
        this.atualizarDadosEquipeNoSharedService();
      }
    });

    // Desabilitar data fim inicialmente
    this.form.get("dataFimRealizacao")?.disable();

    // Outros subscribers...
    this.validacaoRequestSubscription = this.sharedService.getValidacaoRequest().subscribe(() => {
      if (!this.jaRespondeuValidacao) {
        this.executarValidacaoEResponder();
      }
    });

    this.buscar();
  }

  ngOnDestroy(): void {
    if (this.clickEventSubscription) {
      this.clickEventSubscription.unsubscribe();
    }
    if (this.validacaoRequestSubscription) {
      this.validacaoRequestSubscription.unsubscribe();
    }

    if (this.sincronizacaoSubscription) {
      this.sincronizacaoSubscription.unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    this.subtipoDataSource.paginator = this.tableOnePaginator;
    this.subtipoDataSource.sort = this.tabela1;
    this.subtipoDataSource.sortingDataAccessor = this.sortingDataAccessor;
    this.equipeDataSource.paginator = this.tableTwoPaginator;
    this.equipeDataSource.sort = this.tabela2;
    this.equipeDataSource.sortingDataAccessor = this.sortingDataAccessor;
  }

  private executarValidacaoEResponder() {
    this.jaRespondeuValidacao = true;
    const validacao = this.executarValidacoes();
    this.sharedService.sendValidacaoResponse(validacao.sucesso, validacao.mensagem);

    setTimeout(() => {
      this.jaRespondeuValidacao = false;
    }, 500);
  }

  public async buscar() {
    try {
      const res = await this.osaService.obterPorId(this.id);

      if (res.sucesso) {
        this.model = res.dados;
        this.isCalculating = true;
        this.configurarDataElaboracao();

        if (res.dados.dataInicioRealizacao) {
          const dataInicioDate = new Date(res.dados.dataInicioRealizacao);
          this.form.get("dataInicioRealizacao")?.setValue(
            convertDate(dataInicioDate),
            { emitEvent: false }
          );
          this.minDataFim = dataInicioDate.toISOString().split("T")[0];
        } else {
          // Se não há data início, usar data elaboração como padrão
          this.form.get("dataInicioRealizacao")?.setValue(
            convertDate(new Date(res.dados.dataElaboracao)),
            { emitEvent: false }
          );
          // Configurar minDataFim baseado na data elaboração
          const dataElaboracaoDate = new Date(res.dados.dataElaboracao);
          this.minDataFim = dataElaboracaoDate.toISOString().split("T")[0];
        }

        // Configurar data fim
        if (res.dados.dataFimRealizacao) {
          this.form.get("dataFimRealizacao")?.setValue(
            convertDate(new Date(res.dados.dataFimRealizacao)),
            { emitEvent: false }
          );
          this.form.get("dataFimRealizacao")?.enable();
        } else if (this.minDataFim) {
          // Se há data início mas não data fim, habilitar campo
          this.form.get("dataFimRealizacao")?.enable();
        } else {
          // Se não há data início, desabilitar data fim
          this.form.get("dataFimRealizacao")?.disable();
        }

        // Configurar outras datas...
        if (res.dados.dataElaboracao) {
          this.form.get("dataElaboracao")?.setValue(
            convertDate(new Date(res.dados.dataElaboracao)),
            { emitEvent: false }
          );
        }

        if (res.dados.dataConstatacoesPreliminares) {
          this.form.get("dataConstatacoesPreliminares")?.setValue(
            convertDate(new Date(res.dados.dataConstatacoesPreliminares)),
            { emitEvent: false }
          );
        }

        if (res.dados.dataApresentacaoRelatorio) {
          this.form.get("dataApresentacaoRelatorio")?.setValue(
            convertDate(new Date(res.dados.dataApresentacaoRelatorio)),
            { emitEvent: false }
          );
        }
        // Resto da configuração do formulário...
        this.form.get("notaRodape")?.setValue(res.dados.notaRodape, { emitEvent: false });
        this.form.get("auditor")?.setValue(res.dados.nomeAuditor, { emitEvent: false });

        this.sharedService.setAuditorId(res.dados.auditorId);

        if (res.dados?.periodoAuditado) {
          this.form.get("periodoAuditado")?.setValue(res.dados.periodoAuditado, { emitEvent: false });
        }

        if (res.dados.qtdeDiasUteisExecucao) {
          this.form.get("qtdeDiasUteisExecucao")?.setValue(this.model.qtdeDiasUteisExecucao, {
            emitEvent: false,
          });
        }

        this.isSubsidiaria = ['Subsidiária', 'Subsidiária e Consultada'].includes(this.model.statusUg);

        this.isCalculating = false;
        this.calcularCamposFaltantes();

        // Resto do código existente...
        this.alocarEquipeModel.unidadeGestora = this.model.planejamento?.opa?.unidadeGestora;
        this.alocarEquipeModel.tipoAuditoria = this.model?.planejamento?.opa?.tipoAuditoria;

        const resSubtipos = await this.osaService.obterUgSubTipo(res.dados.planejamentoId);

        if (resSubtipos.sucesso && resSubtipos.dados) {
          const subtiposUnicos = resSubtipos.dados
            .map(item => ({
              id: item.subTipoAuditoriaId,
              nome: item.subtipoAuditoriaNome
            }))
            .filter((subtipo, index, array) =>
              array.findIndex(s => s.id === subtipo.id) === index
            );

          this.subtipoDataSource.data = subtiposUnicos;
          this.subtipoDataSource.paginator = this.tableOnePaginator;
          this.subtipoDataSource.sort = this.tabela1;
          this.subtipoDataSource.sortingDataAccessor = this.sortingSubtiposDataAccessor;

          const unidadesUnicas = resSubtipos.dados
            .map(item => ({
              id: item.unidadeGestoraId,
              nome: item.unidadeGestoraNome,
              sigla: item.siglaUg
            }))
            .filter((unidade, index, array) =>
              array.findIndex(u => u.id === unidade.id) === index
            );

          this.unidadeGestoraSubtipo = unidadesUnicas;


        }
        const filtro = {
          planejamentoId: res.dados.planejamentoId
        } as IOsaFiltroModel;

        const itens = await this.osaService.obter(filtro);

        const planejamentoUgSubtipoComNumeroOsa = resSubtipos.dados?.map(ugSubtipo => {
          const itemCorrespondente = itens.resultado?.find(item =>
            item.unidadeGestoraId === ugSubtipo.unidadeGestoraId
          );

          return {
            ...ugSubtipo,
            numeroOsa: itemCorrespondente?.numero || null
          };
        }) || [];

        this.dataSourceUgSubTipos.data = planejamentoUgSubtipoComNumeroOsa;
        this.dataSourceUgSubTipos.paginator = this.tableTreePaginator;
        this.dataSourceUgSubTipos.sort = this.tabela3;
        this.dataSourceUgSubTipos.sortingDataAccessor = this.sortingUgSubtiposDataAccessor;
        await this.obterAlocarEquipe();
        this.ocultaSalvar = this.model?.statusUg?.includes('Subsidiária') || false;
      }
    } catch (err) {
      this.exibirMensagemErro(err?.mensagem?.descricao);
      this.router.navigate(["/osa"]);
    }
  }
  private executarValidacoes(): {sucesso: boolean, mensagem?: string} {
    this.submitted = true;

    // Validação 1: Campos obrigatórios básicos do formulário
    if (this.form.invalid) {
      return {
        sucesso: false,
        mensagem: "Preencha todos os campos obrigatórios"
      };
    }

    if (!this.versao && (!this.model?.status || this.model.status.codigo !== 1)) {
      return {
        sucesso: false,
        mensagem: "A OSA deve estar com status 'Em elaboração' para ser enviada para aprovação"
      };
    }

    // Validação 3: Período a ser auditado
    const periodoAuditado = this.form.get("periodoAuditado")?.value;
    if (!periodoAuditado || periodoAuditado.trim() === '') {
      return {
        sucesso: false,
        mensagem: "O campo 'Período a ser auditado' é obrigatório"
      };
    }

    // Validação 4: Data Início da Execução
    const dataInicioExecucao = this.form.get("dataInicioRealizacao")?.value;
    if (!dataInicioExecucao) {
      return {
        sucesso: false,
        mensagem: "O campo 'Data Início da Execução' é obrigatório"
      };
    }

    // Validação 5: Data Fim da Execução
    const dataFimExecucao = this.form.get("dataFimRealizacao")?.value;
    if (!dataFimExecucao) {
      return {
        sucesso: false,
        mensagem: "O campo 'Data Fim da Execução' é obrigatório"
      };
    }

    // Validação 6: Data das constatações preliminares (OBRIGATÓRIA para aprovação)
    const dataConstatacoes = this.form.get("dataConstatacoesPreliminares")?.value;
    if (!dataConstatacoes) {
      return {
        sucesso: false,
        mensagem: "O campo 'Data das constatações preliminares' é obrigatório"
      };
    }

    // Validação 7: Data para apresentação do relatório (OBRIGATÓRIA para aprovação)
    const dataRelatorio = this.form.get("dataApresentacaoRelatorio")?.value;
    if (!dataRelatorio) {
      return {
        sucesso: false,
        mensagem: "O campo 'Data para apresentação do relatório' é obrigatório"
      };
    }

    // Validação 8: Equipe alocada
    if (!this.equipeDataSource.data || this.equipeDataSource.data.length === 0) {
      return {
        sucesso: false,
        mensagem: "É necessário alocar pelo menos um auditor à equipe"
      };
    }

    // Validação 9: Coordenador selecionado
    if (!this.model?.auditorId) {
      return {
        sucesso: false,
        mensagem: "É necessário selecionar um coordenador da auditoria"
      };
    }

    // Validação 10: Quantidade de dias úteis
    const qtdeDias = this.form.get("qtdeDiasUteisExecucao")?.value;
    if (!qtdeDias || qtdeDias <= 0) {
      return {
        sucesso: false,
        mensagem: "A quantidade de dias úteis deve ser maior que zero"
      };
    }

    // Validação 11: Datas relativas - sequência cronológica
    const validacaoDatas = this.validarDatasRelativas();
    if (!validacaoDatas.sucesso) {
      return validacaoDatas;
    }

    // Validação 12: Validação adicional das datas em sequência para aprovação
    const validacaoSequencialDatas = this.validarSequenciaCompletaDatas();
    if (!validacaoSequencialDatas.sucesso) {
      return validacaoSequencialDatas;
    }

    return {sucesso: true};
  }

  private validarSequenciaCompletaDatas(): {sucesso: boolean, mensagem?: string} {
    const dataInicio = new Date(this.form.get("dataInicioRealizacao")?.value);
    const dataFim = new Date(this.form.get("dataFimRealizacao")?.value);
    const dataConstatacoes = new Date(this.form.get("dataConstatacoesPreliminares")?.value);
    const dataRelatorio = new Date(this.form.get("dataApresentacaoRelatorio")?.value);

    // Validar sequência: dataInicio <= dataFim <= dataConstatacoes <= dataRelatorio

    if (dataInicio > dataFim) {
      return {
        sucesso: false,
        mensagem: "Data de início da execução não pode ser maior que a data fim de execução"
      };
    }

    if (dataConstatacoes < dataFim) {
      return {
        sucesso: false,
        mensagem: "Data das constatações preliminares deve ser posterior à data fim da execução"
      };
    }

    if (dataRelatorio < dataConstatacoes) {
      return {
        sucesso: false,
        mensagem: "Data para apresentação do relatório deve ser posterior à data das constatações preliminares"
      };
    }

    return {sucesso: true};
  }


  private executarSalvamento() {
    const validacao = this.executarValidacoes();

    if (!validacao.sucesso) {
      this.exibirMensagemAlerta(validacao.mensagem);
      return;
    }

    const itemFiltrado = this.model.planejamento?.planejamentoUgSubtipo?.find(
      item => item.unidadeGestoraId === this.model.unidadeGestoraId
    );
    const statusUg = itemFiltrado?.statusUg || '';

    const dados = {
      dataInicioRealizacao: new Date(
        this.form.get("dataInicioRealizacao").value
      ),
      dataFimRealizacao: new Date(
        this.form.get("dataFimRealizacao").value
      ),
      dataConstatacoesPreliminares: this.form.get("dataConstatacoesPreliminares").value
        ? new Date(this.form.get("dataConstatacoesPreliminares").value)
        : null,
      dataApresentacaoRelatorio: this.form.get("dataApresentacaoRelatorio").value
        ? new Date(this.form.get("dataApresentacaoRelatorio").value)
        : null,
      qtdeDiasUteisExecucao: this.form.get("qtdeDiasUteisExecucao").value,
      auditorId: this.model?.auditorId,
      notaRodape: this.form.get("notaRodape").value,
      periodoAuditado: this.form.get("periodoAuditado").value,
      ...(this.versao && this.dadosEquipeParaSalvar && { alocarEquipeOsa: this.dadosEquipeParaSalvar }),
      statusUg: statusUg,
      planejamentoId: this.model.planejamentoId,
    } as any;

    this.osaService
      .salvarOsa(this.id, dados)
      .then((res) => {
        if (res.sucesso) {
          this.buscar();
          this.exibirMensagemSucesso(res.mensagem.descricao);
        } else {
          this.exibirMensagemErro(res.mensagem.descricao);
          console.error('Erro no salvamento:', res.mensagem.descricao);
        }
      })
      .catch((err) => {
        this.exibirMensagemErro(err.mensagem.descricao);
        console.error('Erro durante salvamento:', err);
      });
  }

  private sincronizarDadosNoModel(): void {
    if (!this.model) {
      return;
    }

    const formValues = this.form.value;

    // Sincronizar todas as datas obrigatórias
    if (formValues.dataInicioRealizacao) {
      this.model.dataInicioRealizacao = new Date(formValues.dataInicioRealizacao);
    }

    if (formValues.dataFimRealizacao) {
      this.model.dataFimRealizacao = new Date(formValues.dataFimRealizacao);
    }

    // Datas opcionais - sempre sincronizar (null se vazio)
    this.model.dataConstatacoesPreliminares = formValues.dataConstatacoesPreliminares
      ? new Date(formValues.dataConstatacoesPreliminares)
      : null;

    this.model.dataApresentacaoRelatorio = formValues.dataApresentacaoRelatorio
      ? new Date(formValues.dataApresentacaoRelatorio)
      : null;

    // Campos de texto e números
    this.model.qtdeDiasUteisExecucao = formValues.qtdeDiasUteisExecucao;
    this.model.notaRodape = formValues.notaRodape || '';
    this.model.periodoAuditado = formValues.periodoAuditado || '';

    // Sincronizar statusUg baseado no planejamento
    if (this.model.planejamento?.planejamentoUgSubtipo) {
      const itemFiltrado = this.model.planejamento.planejamentoUgSubtipo.find(
        item => item.unidadeGestoraId === this.model.unidadeGestoraId
      );
      this.model.statusUg = itemFiltrado?.statusUg || '';
    }

    this.sharedService.sendModelAtualizado(this.model);
    this.atualizarDadosEquipeNoSharedService();
  }

  private atualizarDadosEquipeNoSharedService(): void {
    if (!this.equipeDataSource?.data?.length || !this.alocarEquipeModel) {
      return;
    }

    const coordenacaoAtualId = this.alocarEquipeModel.tipoAuditoria?.coordenacaoId;
    const auditoresSelecionados = this.equipeDataSource.data;

    // Criar um registro individual para cada auditor (sem agrupar)
    const equipes: ISalvarAlocarEquipeModel[] = auditoresSelecionados.map(auditor => {
      // Verificar se o auditor é convidado (de outra coordenação)
      const isConvidado = auditor.coordenacaoId !== coordenacaoAtualId;

      const convidados = isConvidado ? [{
        auditorId: String(auditor.auditorId),
        nomeAuditor: auditor.nomeAuditor,
        coordenacaoId: auditor.coordenacaoId
      }] : [];

      return {
        auditorId: [String(auditor.auditorId)],
        dataInicio: null,
        dataFim: null,
        unidadeVinculadas: auditor.unidadesVinculadas || [],
        convidados: convidados
      };
    });

    if (this.versao) {
      this.sharedService.sendDadosEquipeNovaVersao(equipes);
    }
  }

  public onSalvar() {
    this.executarSalvamento();
  }

  private calcularCamposFaltantes(): void {
    const dataInicio = this.form.get("dataInicioRealizacao")?.value;
    const dataFim = this.form.get("dataFimRealizacao")?.value;
    const qtdeDias = this.form.get("qtdeDiasUteisExecucao")?.value;

    if (dataInicio && dataFim && !qtdeDias) {
      this.recalcularQtdeDiasUteis();
    } else if (dataInicio && qtdeDias && !dataFim) {
      this.calcularDataFimRealizacao();
    }
  }

  public isArray(value: any): boolean {
    return Array.isArray(value);
  }

  calcularDataFimRealizacao(): void {
    const inicio = new Date(this.form.get("dataInicioRealizacao")?.value);
    const diasUteis = this.form.get("qtdeDiasUteisExecucao")?.value;

    if (!inicio || !diasUteis || isNaN(diasUteis) || diasUteis <= 0) return;

    this.isCalculating = true;

    let diasUteisContados = 0;
    const dataAtual = new Date(inicio);

    while (diasUteisContados < diasUteis) {
      const diaSemana = dataAtual.getDay();

      if (diaSemana >= 1 && diaSemana <= 5) {
        diasUteisContados++;
      }
      if (diasUteisContados < diasUteis) {
        dataAtual.setDate(dataAtual.getDate() + 1);
      }
    }


    this.form
      .get("dataFimRealizacao")
      ?.setValue(convertDate(dataAtual), { emitEvent: false });

    this.isCalculating = false;
  }
  private configurarDataElaboracao(): void {
    if (this.model?.dataElaboracao) {
      const dataElaboracaoDate = new Date(this.model.dataElaboracao);
      this.dataElaboracao = dataElaboracaoDate.toISOString().split("T")[0];
    } else {
      // Se não há data de elaboração, usar data atual como fallback
      this.dataElaboracao = new Date().toISOString().split("T")[0];
    }
  }


  atualizarMinDataFim(): void {
    const inicio = this.form.get("dataInicioRealizacao")?.value;

    if (inicio) {
      const dataInicio = new Date(inicio);
      this.minDataFim = dataInicio.toISOString().split("T")[0];

      const fim = this.form.get("dataFimRealizacao")?.value;
      if (fim) {
        const dataFim = new Date(fim);
        if (dataFim < dataInicio) {
          this.form.get("dataFimRealizacao")?.setValue(null);
        }
      }

      this.form.get("dataFimRealizacao")?.enable();
    } else {
      this.minDataFim = null;
      this.form.get("dataFimRealizacao")?.setValue(null);
      this.form.get("dataFimRealizacao")?.disable();
    }
  }

  validarDataFim(): void {
    const inicio = this.form.get("dataInicioRealizacao")?.value;
    const fim = this.form.get("dataFimRealizacao")?.value;

    if (inicio && fim) {
      const dataInicio = new Date(inicio);
      const dataFim = new Date(fim);

      if (dataFim < dataInicio) {
        // Limpar a data fim inválida
        this.form.get("dataFimRealizacao")?.setValue(null);
        this.exibirMensagemAlerta("A data fim não pode ser anterior à data de início da execução.");
      }
    }
  }

  recalcularQtdeDiasUteis(): void {

    const inicioValue = this.form.get("dataInicioRealizacao")?.value;
    const fimValue = this.form.get("dataFimRealizacao")?.value;


    const inicio = new Date(inicioValue + 'T00:00:00');
    const fim = new Date(fimValue + 'T00:00:00');

    this.isCalculating = true;

    let diasUteis = 0;
    const dataAtual = new Date(inicio);

    while (dataAtual <= fim) {
      const diaSemana = dataAtual.getDay();

      if (diaSemana >= 1 && diaSemana <= 5) {
        diasUteis++;
      }

      dataAtual.setDate(dataAtual.getDate() + 1);
    }

    this.model.qtdeDiasUteisExecucao = diasUteis;
    this.form.get("qtdeDiasUteisExecucao")?.setValue(diasUteis, { emitEvent: false });
    this.isCalculating = false;
  }


  validarDatasRelativas(): {sucesso: boolean, mensagem?: string} {
    const dataInicio = new Date(
      this.form.get("dataInicioRealizacao")?.value
    );
    const dataFim = new Date(this.form.get("dataFimRealizacao")?.value);

    // REGRA PRINCIPAL: dataInicioRealizacao não pode ser maior que dataFimRealizacao
    if (dataInicio > dataFim) {
      return {
        sucesso: false,
        mensagem: "Data de início da execução não pode ser maior que a data fim de execução."
      };
    }

    // Validações adicionais (opcionais)
    const dataConstatacoes = this.form.get("dataConstatacoesPreliminares")
      ?.value
      ? new Date(this.form.get("dataConstatacoesPreliminares")?.value)
      : null;

    const dataRelatorio = this.form.get("dataApresentacaoRelatorio")?.value
      ? new Date(this.form.get("dataApresentacaoRelatorio")?.value)
      : null;

    // Data de constatações deve ser após ou igual à data fim da execução
    if (dataConstatacoes && dataConstatacoes < dataFim) {
      return {
        sucesso: false,
        mensagem: "Data das Constatações Preliminares não pode ser menor que a Data Fim da execução."
      };
    }

    // Data do relatório deve ser após ou igual à data de constatações
    if (
      dataRelatorio &&
      dataConstatacoes &&
      dataRelatorio < dataConstatacoes
    ) {
      return {
        sucesso: false,
        mensagem: "Data para apresentação do relatório não pode ser menor que a Data de constatações preliminares."
      };
    }

    return {sucesso: true};
  }

  adicionarDiasUteis(data: Date, dias: number): Date {
    let count = 0;
    const novaData = new Date(data);
    while (count < dias) {
      novaData.setDate(novaData.getDate() + 1);
      const dia = novaData.getDay();
      if (dia !== 0 && dia !== 6) count++;
    }
    return novaData;
  }

  public obterCoordenadoresAuditoria(): Promise<IAuditorCoordenacaoModel[]> {
    return new Promise((resolve) => {
      this.coordenacaoService
        .obterCoordenadoresAtivos()
        .then((res) => {
          if (res.sucesso) {
            resolve(res.dados);
          } else {
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "error",
              text: res.mensagem.descricao,
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
            });
          }
        })
        .catch((err) => {
          this.exibirMensagemErro(err.mensagem.descricao);
        });
    });
  }

  public obterAlocarEquipe() {
    this.osaService.obterAlocarEquipeOsaId(this.id).then((res) => {
      let auditoresSelecionados = res.dados.map((a) => {
        return {
          auditorId: a.auditorId,
          nomeAuditor: a.nomeAuditor,
          id: a.id,
          unidadesVinculadas: a.unidadesVinculadas
            ? a.unidadesVinculadas.split(',').map(u => u.trim()).filter(u => u.length > 0)
            : [],
        } as IAuditorModel;
      });

      // Remover items duplicados
      auditoresSelecionados = auditoresSelecionados.filter(function (a) {
        return (
          !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true)
        );
      }, Object.create(null));

      this.equipeDataSource.data = auditoresSelecionados;
      this.alocarEquipeModel.auditoresSelecionados =
        auditoresSelecionados;

      if (auditoresSelecionados.length > 0) {
        this.verificarDisponibilidadeAuditores();
      }
      if (this.versao && auditoresSelecionados.length > 0) {
        this.atualizarDadosEquipeNoSharedService();
      }
    });
  }

  private verificarDisponibilidadeAuditores() {
    const auditores: ISalvarAlocarEquipeModel = {
      auditorId: this.alocarEquipeModel.auditoresSelecionados.map(item => String(item.auditorId)),
      dataInicio: this.model.dataInicioRealizacao,
      dataFim: this.model.dataFimRealizacao,
      convidados: []
    };

    this.osaService.verificaAlocacao(auditores).then((res) => {
      if (res.sucesso && res.dados) {
        this.alocarEquipeModel.auditoresSelecionados.forEach(auditor => {
          const alocado = res.dados.alocados?.find(a => a.auditorId === auditor.auditorId);
          const dispensado = res.dados.dispensados?.find(a => a.auditorId === auditor.auditorId);

          auditor.indisponivelPeriodo = !!alocado || !!dispensado;

          if (dispensado) {
            auditor.nomeDispensa = dispensado.nomeDispensa || '';
          } else {
            auditor.nomeDispensa = '';
          }
        });

        // Atualizar o dataSource para refletir as mudanças na tabela
        this.equipeDataSource.data = [...this.alocarEquipeModel.auditoresSelecionados];
      }
    }).catch(() => {
      this.exibirMensagemSucesso('Erro ao verificar disponibilidade dos auditores.');
    });
  }

  public async exibirModalAlocarEquipe() {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = "modal-component";
      dialogConfig.width = "650px";
      dialogConfig.maxHeight = "80vh";
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = this.alocarEquipeModel;
      const modal = this.matDialog.open(
        ModalAlocarEquipeOsaComponent,
        dialogConfig
      );
      modal.afterClosed().subscribe(async (sucesso: IAlocarEquipeModel) => {
        if (sucesso) {
          const coordenacaoAtualId = this.alocarEquipeModel.tipoAuditoria?.coordenacaoId;

          const convidados = sucesso.auditoresSelecionados
            .filter(auditor => auditor.coordenacaoId !== coordenacaoAtualId)
            .map(auditor => ({
              auditorId: String(auditor.auditorId),
              nomeAuditor: auditor.nomeAuditor,
              coordenacaoId: auditor.coordenacaoId
            }));

          const dados: ISalvarAlocarEquipeModel = {
            auditorId: sucesso.auditoresSelecionados.map(item => String(item.auditorId)),
            dataInicio: null,
            dataFim: null,
            convidados: convidados
          };

          if (!this.versao) {
            // Modo normal: Salva e deixa o buscar() atualizar o dataSource
            this.osaService
              .salvarAlocarEquipeOsaId(this.id, dados)
              .then((res) => {
                if (res.sucesso) {
                  this.buscar(); // Atualiza dataSource com dados completos do backend
                  this.exibirMensagemSucesso(res.mensagem.descricao);
                } else {
                  this.exibirMensagemErro(res.mensagem.descricao);
                }
              });
          } else {
            // Modo versão: Atualiza localmente mantendo as UGs
            const auditoresAtualizados = sucesso.auditoresSelecionados.map(novoAuditor => {
              const auditorExistente = this.alocarEquipeModel.auditoresSelecionados?.find(
                a => a.auditorId === novoAuditor.auditorId
              );

              return {
                ...novoAuditor,
                unidadesVinculadas: auditorExistente?.unidadesVinculadas || novoAuditor.unidadesVinculadas || []
              };
            });

            this.alocarEquipeModel.auditoresSelecionados = auditoresAtualizados;
            this.alocarEquipeModel.dataInicio = sucesso?.dataInicio;
            this.alocarEquipeModel.dataFim = sucesso?.dataFim;

            // Verificar disponibilidade
            if (auditoresAtualizados.length > 0 &&
              this.model.dataInicioRealizacao && this.model.dataFimRealizacao) {
              const auditores: ISalvarAlocarEquipeModel = {
                auditorId: auditoresAtualizados.map(item => String(item.auditorId)),
                dataInicio: this.model.dataInicioRealizacao,
                dataFim: this.model.dataFimRealizacao,
                convidados: []
              };

              try {
                const res = await this.osaService.verificaAlocacao(auditores);
                if (res.sucesso && res.dados) {
                  this.alocarEquipeModel.auditoresSelecionados.forEach(auditor => {
                    auditor.indisponivelPeriodo =
                      res.dados.alocados?.some(a => a.auditorId === auditor.auditorId) ||
                      res.dados.dispensados?.some(a => a.auditorId === auditor.auditorId) ||
                      false;
                  });
                }
              } catch (error) {
                this.exibirMensagemErro('Erro ao verificar disponibilidade dos auditores.');
              }
            }

            // Atualizar dataSource apenas no modo versão
            this.equipeDataSource.data = this.alocarEquipeModel.auditoresSelecionados;
            this.semDados = this.equipeDataSource.filteredData.length === 0;
            this.equipeDataSource.paginator = this.tableTwoPaginator;
            this.equipeDataSource.sort = this.tabela2;
            this.equipeDataSource.sortingDataAccessor = this.sortingDataAccessor;

            this.atualizarDadosEquipeNoSharedService();
          }
        }
      });
    } catch (err) {
      this.exibirMensagemErro(err.mensagem.descricao);
    }
  }

  public desvincularAuditor(element: number) {
    if (this.versao) {
      const auditorIndex = this.equipeDataSource.data.findIndex(
        (auditor: IAuditorModel) => auditor.id === element
      );

      if (auditorIndex !== -1) {
        // Remove o auditor do dataSource
        this.equipeDataSource.data = this.equipeDataSource.data.filter(
          (auditor: IAuditorModel) => auditor.id !== element
        );

        // Atualiza o modelo
        this.alocarEquipeModel.auditoresSelecionados = [...this.equipeDataSource.data];

        // Atualiza o semDados
        this.semDados = this.equipeDataSource.data.length === 0;

        // Se ainda houver auditores, atualiza os dados no SharedService
        if (this.equipeDataSource.data.length > 0) {
          this.atualizarDadosEquipeNoSharedService();
        } else {
          // Se não houver mais auditores, limpa os dados
          this.sharedService.sendDadosEquipeNovaVersao(null);
        }

        this.exibirMensagemSucesso("Auditor desvinculado com sucesso");
      } else {
        this.exibirMensagemErro("Auditor não encontrado");
      }
    } else {
      // Modo normal: desvincula diretamente no backend
      this.osaService
        .desvincularAuditorId(this.id, element, this.model.planejamentoId)
        .then((res) => {
          if (res.sucesso) {
            this.exibirMensagemSucesso(res.mensagem.descricao);
          } else {
            this.exibirMensagemErro(res.mensagem.descricao);
          }
        })
        .then(() => this.buscar());
    }
  }

  public abrirModalVincularUnidade(element: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-component-vincular-ug";
    dialogConfig.width = "650px";
    dialogConfig.maxHeight = "80vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      displayedColumns: this.displayedColumns,
      data: {
        unidadesGestoras: this.unidadeGestoraSubtipo,
      }
    };

    const modal = this.matDialog.open(
      ModalVincularUgComponentComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((data: any) => {
      if (data && data.length > 0) {
        this.vincularUgsAoAuditor(element, data);
      }
    });
  }
  private vincularUgsAoAuditor(auditorDados: any, ugsSelecionadas: IUnidadeGestoraModel[]) {
    // Encontrar o auditor pelo ID
    const auditorIndex = this.equipeDataSource.data.findIndex(
      (auditor: IAuditorModel) => auditor.id === auditorDados.id
    );

    if (auditorIndex !== -1) {
      const auditorParaAtualizar = this.equipeDataSource.data[auditorIndex];

      const siglasVinculadas = ugsSelecionadas.map(ug => ug.sigla);
      auditorParaAtualizar.unidadesVinculadas = siglasVinculadas;

      this.equipeDataSource.data = [...this.equipeDataSource.data];

      const dados: ISalvarAlocarEquipeModel = {
        auditorId: [auditorDados.auditorId],
        dataInicio: null,
        dataFim: null,
        convidados: [],
        unidadeVinculadas: siglasVinculadas
      }

      if(!this.versao){
        this.osaService
          .salvarVincularEquipeOsaId(this.id,this.model.planejamentoId, dados)
          .then((res) => {
            if (res.sucesso) {
              this.exibirMensagemSucesso(
                res.mensagem.descricao
              );
            } else {
              this.exibirMensagemSucesso(
                res.mensagem.descricao
              );
            }
          });
      }else{
        this.atualizarDadosEquipeNoSharedService();

      }

    } else {
      console.error('Auditor não encontrado com ID:', auditorDados.id);
    }
  }


  public async exibirModalSubtipo() {
    try {
      const res = await this.subtipoService.obterAtivos();
      if (res.sucesso) {
        const modal = this.exibirModal(
          "Selecionar Subtipo de Auditoria",
          res.dados
        );
        modal.afterClosed().subscribe((data) => {
          if (data) {
            this.subTipoModel.push(data);
          }
        });
      } else {
        this.exibirMensagemErro(res.mensagem.descricao);
      }
    } catch (err) {
      this.exibirMensagemErro(err.mensagem.descricao);
    }
  }

  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "auditor":
        return item?.nomeAuditor;
      case "nome":
        return item?.nome;
      default:
        return item[property];
    }
  };

  public sortingSubtiposDataAccessor = (item, property) => {
    switch (property) {
      case "nome":
        return item?.subTipoAuditoria?.nome;
      default:
        return item[property];
    }
  };

  public sortingUgSubtiposDataAccessor = (item, property) => {
    switch (property) {
      case "nome":
        return item?.subTipoAuditoria?.nome;
      default:
        return item[property];
    }
  };

  public async exibirModalCoordenadorAuditoria() {
    try {
      const res =
        await this.coordenacaoService.obterCoordenadoresAtivos();
      if (res) {
        const newCordenador = (res.dados || [])
          .filter((item) => item?.auditorId && item?.nomeAuditor)
          .map((item) => ({
            id: item.auditorId,
            nome: item.nomeAuditor,
          }));
        const modal = this.exibirModal(
          "Selecionar Coordenador da Auditoria",
          newCordenador,
          false
        );
        modal.afterClosed().subscribe((data) => {
          if (data) {
            this.model.auditorCoordenacao = data;
            this.model.auditorId = data?.id;
            this.form.controls["auditor"].setValue(data?.nome);

            // CORREÇÃO: Atualizar dados no SharedService após mudança do coordenador
            if (this.versao) {
              this.atualizarDadosEquipeNoSharedService();
            }
          }
        });
      } else {
        this.exibirMensagemErro(res.mensagem.descricao);
      }
    } catch (err) {
      this.exibirMensagemErro(err.mensagem.descricao);
    }
  }
}
